import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<div class=\"inner-banner\"><div class=\"container\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"banner-content text-center\"><h1>Unauthorized</h1><span></span></div></div></div></div></div><div class=\"job-listing-area pt-120 mb-120\" id=\"scrollTarget\"><div class=\"container\"></div></div>", 2)
const _hoisted_3 = [
  _hoisted_1
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, _hoisted_3))
}